import { useState } from 'react'
import {
  nextSortState,
  SortState,
} from '@sportninja/common/features/game/attendance/utils/attendanceSort'

/**
 * Per-section sort state for an attendance table. `hasUserSorted` lets a section
 * keep a default grouping (spares-first) until the user picks an explicit sort.
 */
export const useAttendanceSort = () => {
  const [state, setState] = useState<SortState>({
    sortType: 'name',
    sortOrder: 'asc',
  })
  // Bumped to re-snapshot the availability grouping. Sections group by a frozen
  // snapshot so rows don't jump when a status changes; tapping AVAILABLE asks
  // for a fresh one.
  const [availabilityResortKey, setAvailabilityResortKey] = useState(0)
  const [hasUserSorted, setHasUserSorted] = useState(false)

  const handleState = (newType: string) => {
    // AVAILABLE isn't a column sort — it re-groups by the current statuses.
    if (newType === 'available') {
      setHasUserSorted(false)
      setAvailabilityResortKey((k) => k + 1)
      return
    }
    setHasUserSorted(true)
    setState((current) => nextSortState(current, newType))
  }

  return {
    sortType: state.sortType,
    sortOrder: state.sortOrder,
    hasUserSorted,
    availabilityResortKey,
    handleState,
  }
}
